import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FinMark from '../brand/FinMark';
import { BOT_URL, landing } from './tokens';
import { CONTACT_EMAIL } from '../../legal/legalDocument';

const linkSx = {
  color: landing.ink2,
  textDecoration: 'none',
  fontSize: 14,
  '&:hover': { color: landing.ink },
};

const LandingFooter: React.FC = () => {
  const { t } = useTranslation('landing');
  return (
    <Box component='footer' sx={{ borderTop: `1px solid ${landing.line}` }}>
      <Box
        sx={{
          maxWidth: landing.maxWidth,
          mx: 'auto',
          px: 3,
          pt: 4,
          pb: 5,
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2.5,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
          <FinMark size={28} />
          <Box component='span' sx={{ fontSize: 14, color: landing.ink3 }}>
            {t('footer.tagline')}
          </Box>
        </Box>
        <Box component='nav' aria-label={t('footer.label')} sx={{ display: 'flex', flexWrap: 'wrap', columnGap: 2.5, rowGap: 1 }}>
          <Box component={RouterLink} to='/login' sx={linkSx}>
            {t('nav.login')}
          </Box>
          <Box component='a' href={BOT_URL} target='_blank' rel='noopener noreferrer' sx={linkSx}>
            {t('footer.telegram')}
          </Box>
          <Box component={RouterLink} to='/privacidade' sx={linkSx}>
            {t('footer.privacy')}
          </Box>
          <Box component={RouterLink} to='/termos' sx={linkSx}>
            {t('footer.terms')}
          </Box>
          <Box component='a' href={`mailto:${CONTACT_EMAIL}`} sx={linkSx}>
            {CONTACT_EMAIL}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default LandingFooter;
